import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UserInterface } from '@interfaces/user/user.interface';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth/auth.service';
import { ReplaySubject } from 'rxjs';

export interface AlertWarning {
  message?: string;
  subtitle?: string;
  secondSubtitle?: string;
  thirdSubtitle?: string;
  title: string;
  placesVariable?: number;
  mailtoBecubs?: boolean;
}

@Component({
  selector: 'app-alert-message',
  templateUrl: 'alert-message.template.html',
})
export class AlertMessageComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  @Input() visible: boolean;
  @Input() warnings: AlertWarning[] = [];
  constructor(
    private authService: AuthService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
